<om-adult-direct-signup-form (canceled)="returnToDirectSignup()">
  <div class="col-12 col-lg-8 offset-lg-2 pt-3">
    <a (click)="returnToDirectSignup()" class="btn btn-link" data-cy="continue">Continue</a>
  </div>
</om-adult-direct-signup-form>
